import React from 'react'
import PropTypes, { InferProps } from 'prop-types'
import { Text } from 'pcln-design-system'
import { User as UserIcon } from 'pcln-icons'
import StyledMenuButton from './StyledMenuButton'

export default function Menu({
  isPanelOpen = false,
  hasError = false,
  label = '',
  toggleMenu,
  isMobile
}: InferProps<typeof Menu.propTypes>) {
  const borderColorValue = !isPanelOpen && hasError ? 'red' : 'borderGray'
  return (
    <StyledMenuButton
      aria-label="traveler-selection-control-panel"
      id="traveler-selection-readonly-input"
      data-testid="traveler-selection-readonly-input"
      type="button"
      color="text.lightest"
      width={1}
      onClick={toggleMenu(isPanelOpen)}
      borderColor={borderColorValue}
      isMobile={isMobile}
      aria-expanded={isPanelOpen}
      aria-controls="traveler-selection-control-panel"
    >
      <UserIcon color="primary" size={24} />
      <Text aria-live="polite" aria-atomic="true" regular>
        {label}
      </Text>
    </StyledMenuButton>
  )
}

Menu.propTypes = {
  isPanelOpen: PropTypes.bool,
  hasError: PropTypes.bool,
  label: PropTypes.string,
  isMobile: PropTypes.bool,
  toggleMenu: PropTypes.func.isRequired
}
